import { render, staticRenderFns } from "./TenantHead.vue?vue&type=template&id=7a48b0eb&scoped=true&"
import script from "./TenantHead.vue?vue&type=script&lang=ts&"
export * from "./TenantHead.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a48b0eb",
  null
  
)

export default component.exports